export default "__VITE_ASSET__DtJMD0Ri__"